import { render, staticRenderFns } from "./ActivateTenancy.vue?vue&type=template&id=1ea48496&scoped=true"
import script from "./ActivateTenancy.vue?vue&type=script&lang=js"
export * from "./ActivateTenancy.vue?vue&type=script&lang=js"
import style0 from "./ActivateTenancy.vue?vue&type=style&index=0&id=1ea48496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea48496",
  null
  
)

export default component.exports